module.exports = __webpack_public_path__ + "img/club-card-dialog-positive.f9759d26.svg";